import { render } from "./setting-msg-box.vue?vue&type=template&id=02b02df6&scoped=true&ts=true"
import script from "./setting-msg-box.vue?vue&type=script&lang=ts"
export * from "./setting-msg-box.vue?vue&type=script&lang=ts"

import "./setting-msg-box.vue?vue&type=style&index=0&id=02b02df6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b02df6"]])

export default __exports__